import React from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { Select } from "MODULES/shared/components/Forms";
import { toOptions } from "LIB/forms";
import { QUOTE_TYPE } from "MODULES/OutgoingQuotes/constants";
import { properCase } from "LIB/formatters/text";
import {
  MAKE_OFFER,
  NO_QUOTE,
  AWAITING_REPLY,
  EXCHANGE_ONLY,
  SEND_QUOTE
} from "./constants";

export default function IncomingQuoteTypeSelect({
  cost,
  quantity,
  exchange_fee,
  quoteTypes,
  setFieldValue = () => () => {}
}) {
  const handleChange = ev => {
    const newQuoteType = ev.target.value;

    if ([MAKE_OFFER, NO_QUOTE, AWAITING_REPLY].includes(newQuoteType)) {
      cost.input.onChange(0);
    }

    if (newQuoteType !== AWAITING_REPLY) {
      setFieldValue(SEND_QUOTE)(false);
    }

    if (newQuoteType === NO_QUOTE) {
      quantity.input.onChange("0");
    }

    if (newQuoteType !== EXCHANGE_ONLY) {
      exchange_fee.input.onChange(null);
    }
  };

  return (
    <Field
      name={QUOTE_TYPE}
      component={Select}
      options={toOptions(quoteTypes)}
      label={properCase(QUOTE_TYPE)}
      prompt={null}
      onChange={handleChange}
      required
    />
  );
}

IncomingQuoteTypeSelect.propTypes = {
  cost: PropTypes.instanceOf(Object).isRequired,
  quantity: PropTypes.instanceOf(Object).isRequired,
  exchange_fee: PropTypes.instanceOf(Object).isRequired,
  quoteTypes: PropTypes.instanceOf(Object).isRequired,
  setFieldValue: PropTypes.func
};



// WEBPACK FOOTER //
// ./app/modules/IncomingQuotes/IncomingQuoteTypeSelect.jsx